module.exports = new __parcel__URL__("goes-ch4plume--cover.5dd9cb60.png").toString();